import {
  Divider,
  HexIcon,
  SxProps,
  Placeholder as StatusMessage,
  Typography,
} from '@cast/design-system';

type Props = {
  allResolved?: boolean;
  sx?: SxProps;
};

export const NoNotifications = ({ allResolved, sx }: Props) => {
  return (
    <>
      <Divider />
      <StatusMessage
        icon={
          allResolved ? (
            <HexIcon variant="check" size={48} />
          ) : (
            <HexIcon variant="notification" size={48} />
          )
        }
        title={
          <Typography variant="A1" textAlign="center">
            {allResolved
              ? 'All notifications are resolved'
              : 'No notifications yet'}
          </Typography>
        }
        body={
          <Typography variant="P12R" textAlign="center">
            {allResolved
              ? 'New notifications you receive will show up here.'
              : 'All notifications you receive will show up here.'}
          </Typography>
        }
        sx={sx}
      />
    </>
  );
};
